module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"saveConfirm":"Are you sure to save?"},"et":{"saveConfirm":"Are you sure to save?"},"ru":{"saveConfirm":"Are you sure to save?"}}')
  delete Component.options._Ctor
}
